var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlocked = function SvgUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.3966 10.3991H8.44237V8.86331C8.44237 6.93901 10.0151 5.37123 11.9506 5.37123C13.117 5.37123 14.2052 5.94715 14.8596 6.91158C14.9698 7.07156 15.0662 7.24297 15.1466 7.41894C15.305 7.76403 15.7137 7.91487 16.0581 7.75946C16.4048 7.60177 16.5586 7.19726 16.4002 6.85216C16.2877 6.60534 16.1545 6.36766 16.0007 6.14369C15.0892 4.80217 13.5762 4 11.9506 4C9.2781 4 7.09923 6.14598 7.06479 8.79931V10.3991H6.6033C5.90532 10.3991 5.34052 10.9613 5.34052 11.656V18.743C5.34052 19.4378 5.90532 20 6.6033 20H17.3966C18.0946 20 18.6594 19.4378 18.6594 18.743V11.656C18.6594 10.9613 18.0946 10.3991 17.3966 10.3991Z"
  })));
};
export default SvgUnlocked;